import i from "./ghl-ui.es1505.js";
import m from "./ghl-ui.es1506.js";
import n from "./ghl-ui.es1466.js";
function f(r, e) {
  n(2, arguments);
  var t = m(r), o = i(e);
  return t.setMinutes(o), t;
}
export {
  f as default
};
